import React, { useEffect, useState, useRef } from "react";
import {
  Tabs,
  Tab,
  Typography,
  Box,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Paper,
  TableContainer,
  Divider,
  alpha,
} from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import CloseIcon from "@mui/icons-material/Close";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import SavingsOutlinedIcon from "@mui/icons-material/SavingsOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";

const CACHESERVICE = "https://accounts.paybito.com/CacheService/api";
const ASSETICONBASEURL =
  "https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/";

const EarnWallet = () => {
  const { brokerBasicInfo, btncolor, allColors } = useSelector(
    (state) => state
  );

  const [tabIndex, setTabIndex] = useState(0);
  const [totalEarnings, setTotalEarnings] = useState("0.00");
  const [totalEarnWalletValue, setTotalEarnWalletValue] = useState("0.00");
  const [totalInvestment, setTotalInvestment] = useState("0.00");
  const [userInvestmentListForFlexible, setUserInvestmentListForFlexible] =
    useState([]);
  const [
    userInvestmentListForLockInPeriod,
    setUserInvestmentListForLockInPeriod,
  ] = useState([]);
  const [availableRedeemBalance, setAvailableRedeemBalance] = useState("0.00");
  const [unInvestedBalance, setUnInvestedBalance] = useState("0.00");
  const [earnWalletBalance, setEarnWalletBalance] = useState("0.00");
  const [selectedAssetForRedeem, setSelectedAssetForRedeem] = useState(null);
  const [redeemAmount, setRedeemAmount] = useState("");
  const [selectedCurrencyAutoInvestOn, setSelectedCurrencyAutoInvestOn] =
    useState(false);
  const [isRedeemButtonDisable, setIsRedeemButtonDisable] = useState(true);
  const [assets, setAssets] = useState([]);
  const [currencyId, setCurrencyId] = useState("");
  const [selectedInvestmentAutoInvest, setSelectedInvestmentAutoInvest] =
    useState(0);
  const [flexibleEarnList, setFlexibleEarnList] = useState([]);
  const [LockInEarnList, setLockInEarnList] = useState([]);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [homeCurrency, setHomeCurrency] = useState("");
  const [headerDisplayFlag, setHeaderDisplayFlag] = useState(false);
  const [showUncheckAutoInvest, setShowUncheckAutoInvest] = useState(false);
  const [showRedeemModal, setShowRedeemModal] = useState(false);
  const [showConfirmRedeemModal, setShowConfirmRedeemModal] = useState(false);
  const [investmentDurations, setInvestmentDurations] = useState([]);
  const [uncheckAutoInvest, setUncheckAutoInvest] = useState(false);
  const [redeemModal, setRedeemModal] = useState(false);
  const [confirmRedeemModal, setConfirmRedeemModal] = useState(false);

  const handleCloseUncheckAutoInvest = () => setUncheckAutoInvest(false);
  const handleCloseRedeemModal = () => (
    setRedeemModal(false), setRedeemAmount("")
  );
  const handleCloseConfirmRedeemModal = () => setConfirmRedeemModal(false);

  const uncheckAutoInvestRef = useRef(null);
  const redeemModalRef = useRef(null);
  const confirmRedeemModalRef = useRef(null);

  const navigate = useNavigate();

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
    getUserExistingInvestment();
  };

  const investmentSchedules = [
    {
      title: "Flexible One-time",
      hoverText:
        "Your Investment Amount Selection was moved from your spot wallet to your earn wallet and invested to earn interests for only one-time.",
    },
    {
      title: "Flexible Daily Auto-invest",
      hoverText:
        "Your Investment Amount Selection will be moved from your spot wallet to your earn wallet every day at UTC 12:00 AM and invested to earn interests. You can turn this auto-invest feature off from the Auto-invest column here.",
    },
    {
      title: "Flexible Auto-invest Full Wallet Balance",
      hoverText:
        "Your full wallet balance will be moved from your spot wallet to your earn wallet every day at UTC 12:00 AM and invested to earn interests. You can turn this auto-invest feature off from the Auto-invest column here.",
    },
    {
      title: "Lock-in One-time",
      hoverText:
        "Your Investment Amount Selection was moved from your spot wallet to your earn wallet and invested to earn interests into this lock-in period for only one-time. Upon expiry, your assets will automatically earn the corresponding flexible product interest.",
    },
    {
      title: "Lock-in Auto-invest Amount",
      hoverText:
        "Your Investment Amount Selection will be moved from your spot wallet to your earn wallet at the end of every expiry to be invested to earn interests into this lock-in period. You can turn this auto-invest feature off from the Auto-invest column here.",
    },
    {
      title: "Lock-in Auto-invest Full Wallet Balance",
      hoverText:
        "Your full wallet balance will be moved from your spot wallet to your earn wallet at the end of every expiry to be invested to earn interests into this lock-in period. You can turn this auto-invest feature off from the Auto-invest column here.",
    },
  ];

  useEffect(() => {
    getExchangeFeaturesCurrency();
    getAllAsset();
    getUserExistingInvestment();
    getAllInterestDuration();
  }, []);

  const getAllAsset = async () => {
    try {
      const response = await axios.get(
        `${CACHESERVICE}/getAssetsData?Name=Assets&BrokerId=${localStorage.getItem(
          "BROKERID"
        )}`
      );
      let filterCurrency = JSON.parse(response.data.value).Values;

      const updatedAssets = [...assets];
      filterCurrency.forEach((currency) => {
        const exists = updatedAssets.find(
          (a) => a.currencyCode === currency.currencyCode
        );
        if (!exists) {
          updatedAssets.push(currency);
        }
      });

      setAssets(updatedAssets);
    } catch (error) {
      console.error("Error fetching assets:", error);
    }
  };

  const getAllInterestDuration = () => {
    const token = localStorage.getItem("access_token");
    axios
      .get("/crypto/banking/earn/getEarnDurations", {
        baseURL: WEBSERVICE,
        headers: {
          "Content-Type": "application/json",
          Authorization: `BEARER ${token}`,
        },
      })
      .then((res) => {
        if (res.data.error.error_data !== 0) {
          showToast("error", res.data.error.error_msg);
          console.error(res.data.error.error_msg);
        } else {
          setInvestmentDurations(res.data.investmentDurations);
        }
      })
      .catch((error) => {
        console.error("Error fetching durations:", error);
        showToast("error", "An unexpected error occurred.");
      });
  };

  const getInvestementScheduleDetails = (param) => {
    let schedule = {};
    for (let i = 0; i < investmentSchedules.length; i++) {
      if (investmentSchedules[i].title.toLowerCase() === param.toLowerCase()) {
        schedule = investmentSchedules[i];
        break;
      }
    }
    return schedule;
  };

  const handleAutoInvestSelection = (e, i) => {
    setSelectedTransaction(i);
    if (!e.target.checked) {
      setShowUncheckAutoInvest(true);
    } else {
      const payload = {
        investment: {
          uuid: localStorage.getItem("uuid"),
          durationId: i.lockInPeriodId,
          currencyId: i?.assetId,
          autoInvest: "1",
        },
      };
      handleUpdateInvestment(payload);
    }
  };

  const getAssetDetails = (param) => {
    console.log("paramasssss", param);
    let result = {};
    for (let i = 0; i < assets.length; i++) {
      if (assets[i].currencyCode === param || assets[i].currencyId === param) {
        result = assets[i];
        break;
      }
    }
    return result;
  };

  const generatePayloadForNoAutoInvest = () => {
    const payload = {
      investment: {
        uuid: localStorage.getItem("uuid"),
        durationId: selectedTransaction.lockInPeriodId,
        currencyId: selectedTransaction?.assetId,
        autoInvest: "0",
      },
    };
    handleUpdateInvestment(payload);
    setShowUncheckAutoInvest(false);
  };

  const validateRedeemAmount = (val) => {
    if (
      parseFloat(availableRedeemBalance) === 0 ||
      val === "" ||
      parseFloat(val) > parseFloat(earnWalletBalance)
    ) {
      setIsRedeemButtonDisable(true);
    } else if (parseFloat(val) < 0.0001) {
      showToast("error", "The amount should be minimum of 0.0001");
      setIsRedeemButtonDisable(true);
    } else {
      setIsRedeemButtonDisable(false);
    }
  };

  const handleRedeem = (param) => {
    setAvailableRedeemBalance(param.redeemableBalance);
    setUnInvestedBalance(param.unInvestedAmount);
    setEarnWalletBalance(param.totalBalance);
    setSelectedAssetForRedeem(param.asset);
    setSelectedInvestmentAutoInvest(param.autoInvest);
    setCurrencyId(param?.assetId);
    setRedeemModal(true);
  };

  const handleConfirmRedeemModal = () => {
    setShowRedeemModal(false);
    setConfirmRedeemModal(true);
  };

  const confirmRedeem = () => {
    console.log(
      "getAssetDetails(selectedAssetForRedeem)",
      getAssetDetails(selectedAssetForRedeem)["currencyId"]
    );
    const payload = {
      investment: {
        uuid: localStorage.getItem("uuid"),
        currencyId: currencyId,
        amount: redeemAmount,
      },
    };

    axios
      .post(
        WEBSERVICE + "/crypto/banking/earn/redeemEarnInterest",
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      )
      .then((response) => {
        const result = response.data;
        if (result.error.error_data !== 0) {
          showToast("error", result.error.error_msg);
        } else {
          showToast("success", result.error.error_msg);
          setUserInvestmentListForLockInPeriod([]);
          setUserInvestmentListForFlexible([]);
          getUserExistingInvestment();
          setCurrencyId("");
          setShowConfirmRedeemModal(false);
        }
      })
      .catch((reason) => {
        if (reason.response.data.error === "invalid_token") {
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        } else {
          showToast("error", "Could Not Connect To Server");
        }
      });
  };

  const getUserExistingInvestment = () => {
    const payload = {
      uuid: localStorage.getItem("uuid"),
    };

    axios
      .post(
        WEBSERVICE + "/crypto/banking/earn/getEarnInterestsByUser",
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      )
      .then((response) => {
        const result = response.data;

        if (result.error.error_data !== 0) {
          showToast("error", result.error.error_msg);
        } else {
          setUserInvestmentListForLockInPeriod([]);
          setUserInvestmentListForFlexible([]);
          setTotalInvestment(result.totalInvestment);
          setTotalEarnings(result.totalEarnings);
          setTotalEarnWalletValue(
            parseFloat(result.totalInvestment) +
              parseFloat(result.totalEarnings)
          );

          const investmentDetails = result.investmentDetails;
          const lockInPeriods = [];
          const flexiblePeriods = [];

          for (let i = 0; i < investmentDetails.length; i++) {
            if (investmentDetails[i].lockInPeriod !== "Flexible") {
              lockInPeriods.push(investmentDetails[i]);
            } else {
              flexiblePeriods.push(investmentDetails[i]);
            }
          }

          setUserInvestmentListForLockInPeriod(lockInPeriods);
          setUserInvestmentListForFlexible(flexiblePeriods);
        }
      })
      .catch((reason) => {
        if (reason?.response?.data?.error === "invalid_token") {
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        }
      });
  };

  const handleUpdateInvestment = (payload) => {
    axios
      .post(
        WEBSERVICE + "/crypto/banking/earn/updateEarnInterestStatus",
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      )
      .then((response) => {
        const result = response.data;
        if (result.error.error_data !== 0) {
          showToast("error", result.error.error_msg);
        } else {
          showToast("success", result.error.error_msg);
          setUserInvestmentListForLockInPeriod([]);
          setUserInvestmentListForFlexible([]);
          getUserExistingInvestment();
        }
      })
      .catch((reason) => {
        if (reason.response.data.error === "invalid_token") {
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        } else {
          showToast("error", "Could Not Connect To Server");
        }
      });
  };

  const isShowAutoCheckField = (param) => {
    let show = true;
    if (param.investmentSchedule.indexOf("One-time") !== -1) {
      show = false;
    }
    if (param.isFundAllocated !== 1) {
      show = false;
    }
    return show;
  };

  const getExchangeFeaturesCurrency = () => {
    const loggedInCountry = localStorage.getItem("userCountry");
    axios
      .get(
        WEBSERVICE +
          "/home/getExchangeFeaturesCurrency/" +
          loggedInCountry +
          "/" +
          localStorage.getItem("BROKERID")
      )
      .then((res) => {
        setHomeCurrency(res.data.homeCurrency);
        setHeaderDisplayFlag(true);
      });
  };

  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const onlyAmountForCrypto = (e) => {
    const value = e.target.value.replace(/[^0-9.]/g, "");
    setRedeemAmount(value);
    validateRedeemAmount(value);
  };

  const tableColumns = [
    "Asset",
    "Lock-in Period",
    "Investment Schedule",
    "Auto-invest",
    "Inv. Amount",
    "Total Invested",
    "Total Earning",
    "Earn Wallet Balance",
    "Redeemable",
    "Un-invested",
    "Action",
  ];

  const renderTable = (investmentList) => (
    <TableContainer component={Paper} sx={modernTableContainer}>
      <Table sx={tableStyle}>
        <TableHead>
          <TableRow sx={modernTableHeadRow}>
            {tableColumns.map((col, idx) => (
              <TableCell key={idx} sx={modernTableHeadCell}>
                {col}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {investmentList.length > 0 ? (
            investmentList.map((l, i) => (
              <TableRow key={i} sx={modernTableBodyRow}>
                <TableCell sx={modernTableBodyCell}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <img
                      src={`${ASSETICONBASEURL + l.asset}.png`}
                      alt={l.asset}
                      width="20"
                      height="20"
                      style={{ borderRadius: "50%" }}
                    />
                    <Typography sx={{ fontSize: "0.85rem", fontWeight: 600, color: "var(--text-color)" }}>
                      {l.asset}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell sx={modernTableBodyCell}>{l.lockInPeriod}</TableCell>
                <TableCell sx={modernTableBodyCell}>
                  <Tooltip
                    title={
                      getInvestementScheduleDetails(l.investmentSchedule)
                        .hoverText
                    }
                    placement="right"
                    arrow
                  >
                    <Typography
                      sx={{
                        fontSize: "0.82rem",
                        color: "var(--text-color)",
                        cursor: "help",
                        borderBottom: "1px dashed rgba(125,125,125,0.4)",
                        display: "inline",
                      }}
                    >
                      {l.investmentSchedule}
                    </Typography>
                  </Tooltip>
                </TableCell>
                <TableCell sx={modernTableBodyCell}>
                  {isShowAutoCheckField(l) ? (
                    <Checkbox
                      checked={l.autoInvest === 1}
                      onClick={(e) => handleAutoInvestSelection(e, l)}
                      sx={{
                        color: "rgba(125,125,125,0.4)",
                        "&.Mui-checked": { color: btncolor },
                        p: 0.5,
                      }}
                    />
                  ) : (
                    <RemoveIcon sx={{ fontSize: 18, opacity: 0.35, color: "var(--text-color)" }} />
                  )}
                </TableCell>
                <TableCell sx={modernTableBodyCell}>{l.redeemableBalance}</TableCell>
                <TableCell sx={modernTableBodyCell}>{l.totalInvAmount}</TableCell>
                <TableCell sx={{ ...modernTableBodyCell, color: "#16a34a", fontWeight: 600 }}>
                  {l.totalEarning}
                </TableCell>
                <TableCell sx={modernTableBodyCell}>{l.totalBalance}</TableCell>
                <TableCell sx={modernTableBodyCell}>{l.redeemableBalance}</TableCell>
                <TableCell sx={modernTableBodyCell}>{l.unInvestedAmount}</TableCell>
                <TableCell sx={modernTableBodyCell}>
                  <ContainedButton
                    size="small"
                    variant="contained"
                    onClick={() => handleRedeem(l)}
                    sx={{
                      height: 32,
                      px: 2,
                      borderRadius: "8px",
                      textTransform: "none",
                      fontWeight: 600,
                      fontSize: "0.78rem",
                    }}
                  >
                    Redeem
                  </ContainedButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={tableColumns.length} sx={emptyCell}>
                <InboxOutlinedIcon sx={emptyIcon} />
                <Typography sx={emptyText}>
                  You have not added assets from the Earn Interest module yet.
                  Added assets will be visible in your Earn Wallet.
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );

  // ── Stats data ────────────────────────────────────────────────────────────
  const statsMeta = [
    {
      label: "Total Investment",
      value: headerDisplayFlag ? totalInvestment : "—",
      suffix: homeCurrency,
      icon: <MonetizationOnOutlinedIcon sx={{ fontSize: 20 }} />,
      color: btncolor,
    },
    {
      label: "Total Earnings",
      value: headerDisplayFlag ? totalEarnings : "—",
      suffix: homeCurrency,
      icon: <TrendingUpOutlinedIcon sx={{ fontSize: 20 }} />,
      color: "#16a34a",
    },
    {
      label: "Earn Wallet Value",
      value: headerDisplayFlag ? totalEarnWalletValue : "—",
      suffix: homeCurrency,
      icon: <SavingsOutlinedIcon sx={{ fontSize: 20 }} />,
      color: btncolor,
    },
  ];

  return (
    <Box sx={pageWrapper}>
      {/* ── Hero Banner ── */}
      <Box
        sx={{
          ...heroBanner,
          background: `linear-gradient(135deg, ${alpha(
            btncolor || "#1976d2",
            0.95
          )} 0%, ${alpha(btncolor || "#1976d2", 0.72)} 100%)`,
        }}
      >
        <Box sx={heroContent}>
          <Box sx={heroIconBadge}>
            <AccountBalanceWalletOutlinedIcon
              sx={{ color: "#fff", fontSize: 30 }}
            />
          </Box>
          <Box>
            <Typography sx={heroTitle}>Earn Wallet</Typography>
            <Typography sx={heroSubtitle}>
              Track your investments, earnings and redeem your assets from a
              single dashboard
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* ── Stats Strip ── */}
      <Box sx={statsStrip}>
        {statsMeta.map((s, i) => (
          <Box key={i} sx={statCard}>
            <Box
              sx={{
                ...statIconWrap,
                backgroundColor: alpha(s.color || "#1976d2", 0.1),
                color: s.color,
              }}
            >
              {s.icon}
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={statLabel}>{s.label}</Typography>
              {s.suffix && (
                <Typography sx={statSuffix}>({s.suffix})</Typography>
              )}
            </Box>
            <Box sx={statValueWrap}>
              <Typography sx={{ ...statValue, color: s.color }}>
                {s.value}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>

      {/* ── Main Card with Tabs ── */}
      <Box sx={mainCard}>
        <Box sx={tabsWrap}>
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              ...tabsStyle,
              "& .MuiTabs-indicator": {
                backgroundColor: btncolor,
                height: 3,
                borderRadius: "3px 3px 0 0",
              },
              "& .Mui-selected": { color: `${btncolor} !important` },
            }}
          >
            <Tab
              iconPosition="start"
              icon={<AutorenewIcon sx={{ fontSize: 18 }} />}
              label="Flexible"
              sx={tabItem}
            />
            <Tab
              iconPosition="start"
              icon={<SavingsOutlinedIcon sx={{ fontSize: 18 }} />}
              label="Lock-in Period"
              sx={tabItem}
            />
          </Tabs>
        </Box>

        <Box sx={tabPanel}>
          {tabIndex === 0 && renderTable(userInvestmentListForFlexible)}
          {tabIndex === 1 && renderTable(userInvestmentListForLockInPeriod)}
        </Box>
      </Box>

      {/* ── Auto Invest (legacy ref) Uncheck Dialog ── */}
      <Dialog
        open={uncheckAutoInvest}
        onClose={handleCloseUncheckAutoInvest}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          Auto Invest
          <IconButton
            onClick={handleCloseUncheckAutoInvest}
            size="small"
            sx={dialogCloseBtn}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogContent sx={dialogContentStyle}>
          <Typography sx={dialogText}>
            What happens when this auto-invest feature is turned off?
          </Typography>
          <Typography sx={{ ...dialogText, mt: 1.5 }}>
            (1) It will stop auto-investing for you.
          </Typography>
          <Typography sx={{ ...dialogText, mt: 1 }}>
            (2) Your already invested assets will remain in the Earn wallet and
            continue to earn the corresponding flexible product interest.
          </Typography>
        </DialogContent>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogActions sx={dialogActionsStyle}>
          <ContainedButton
            variant="contained"
            sx={{ mx: 1, minWidth: 110 }}
            onClick={() => {
              generatePayloadForNoAutoInvest();
              handleCloseUncheckAutoInvest();
            }}
          >
            Ok
          </ContainedButton>
          <OutlinedButton
            variant="outlined"
            sx={{ mx: 1, minWidth: 110 }}
            onClick={() => {
              getUserExistingInvestment();
              handleCloseUncheckAutoInvest();
            }}
          >
            Cancel
          </OutlinedButton>
        </DialogActions>
      </Dialog>

      {/* ── Redeem Modal ── */}
      <Dialog
        open={redeemModal}
        onClose={handleCloseRedeemModal}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          Redeem
          <IconButton
            onClick={handleCloseRedeemModal}
            size="small"
            sx={dialogCloseBtn}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogContent sx={dialogContentStyle}>
          {/* Balance rows */}
          <Box sx={redeemInfoGrid}>
            <Box sx={redeemInfoRow}>
              <Typography sx={redeemInfoLabel}>
                Available Redeemable Balance
              </Typography>
              <Typography sx={redeemInfoValue}>
                {availableRedeemBalance}
              </Typography>
            </Box>
            <Divider sx={{ borderColor: "rgba(125,125,125,0.1)" }} />
            <Box sx={redeemInfoRow}>
              <Typography sx={redeemInfoLabel}>
                Total Balance in Earn Wallet
              </Typography>
              <Typography sx={redeemInfoValue}>{earnWalletBalance}</Typography>
            </Box>
          </Box>

          <Box sx={{ mt: 2.5 }}>
            <Typography sx={fieldLabelSmall}>Redeem Amount</Typography>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Enter amount"
              value={redeemAmount}
              onChange={onlyAmountForCrypto}
              sx={dialogTextField}
            />
          </Box>

          {/* Warning notes */}
          <Box sx={{ mt: 2 }}>
            {parseFloat(redeemAmount) > unInvestedBalance &&
              parseFloat(redeemAmount) < availableRedeemBalance && (
                <Typography sx={warningText}>
                  * Your requested Redeem amount exceeds your Un-invested
                  Balance. You will stop earning Flexible interests on your
                  asset from this point on.
                </Typography>
              )}
            {parseFloat(redeemAmount) > availableRedeemBalance && (
              <Typography sx={warningText}>
                * Your requested Redeem amount exceeds your Redeemable Balance.
                The exceeded amount will not earn the lock-in period interest.
                You will also stop earning Flexible interests.
              </Typography>
            )}
            <Typography sx={{ ...dialogText, mt: 1, opacity: 0.7 }}>
              * You are about to redeem your Earn Wallet balance to your Spot
              Wallet. You will stop earning interests on your asset from this
              point on.
            </Typography>
            {selectedInvestmentAutoInvest === 1 && (
              <Typography sx={{ ...dialogText, mt: 1, opacity: 0.7 }}>
                * If your Auto-invest feature is on, it will continue to move
                your assets from Spot Wallet to Earn Wallet as per your selected
                Investment Schedule and Investment Amount Selection.
              </Typography>
            )}
          </Box>
        </DialogContent>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogActions sx={dialogActionsStyle}>
          <ContainedButton
            fullWidth
            variant="contained"
            onClick={handleConfirmRedeemModal}
            disabled={isRedeemButtonDisable}
            sx={{ mx: 1 }}
          >
            Submit
          </ContainedButton>
        </DialogActions>
      </Dialog>

      {/* ── Confirm Redeem Modal ── */}
      <Dialog
        open={confirmRedeemModal}
        onClose={handleCloseConfirmRedeemModal}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          Redeem
          <IconButton
            onClick={handleCloseConfirmRedeemModal}
            size="small"
            sx={dialogCloseBtn}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogContent sx={dialogContentStyle}>
          <Typography sx={dialogText}>
            You are about to redeem the Total Balance in your Earn Wallet to
            your Spot Wallet. You will stop earning interests on your asset from
            this point on.
          </Typography>
        </DialogContent>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogActions sx={dialogActionsStyle}>
          <ContainedButton
            variant="contained"
            sx={{ mx: 1, minWidth: 110 }}
            onClick={() => {
              confirmRedeem();
              handleCloseConfirmRedeemModal();
            }}
          >
            Ok
          </ContainedButton>
          <OutlinedButton
            variant="outlined"
            sx={{ mx: 1, minWidth: 110 }}
            onClick={() => {
              getUserExistingInvestment();
              handleCloseConfirmRedeemModal();
            }}
          >
            Cancel
          </OutlinedButton>
        </DialogActions>
      </Dialog>

      {/* ── Show Uncheck Auto Invest Dialog ── */}
      <Dialog
        open={showUncheckAutoInvest}
        onClose={() => setShowUncheckAutoInvest(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          Auto Invest
          <IconButton
            onClick={() => setShowUncheckAutoInvest(false)}
            size="small"
            sx={dialogCloseBtn}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogContent sx={dialogContentStyle}>
          <Typography sx={dialogText}>
            What happens when this auto-invest feature is turned off?
          </Typography>
          <Typography sx={{ ...dialogText, mt: 1.5 }}>
            (1) It will stop auto-investing for you.
          </Typography>
          <Typography sx={{ ...dialogText, mt: 1 }}>
            (2) Your already invested assets will remain in the Earn wallet and
            continue to earn the corresponding flexible product interest.
          </Typography>
        </DialogContent>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogActions sx={dialogActionsStyle}>
          <ContainedButton
            variant="contained"
            sx={{ mx: 1, minWidth: 110 }}
            onClick={generatePayloadForNoAutoInvest}
          >
            Ok
          </ContainedButton>
          <OutlinedButton
            variant="outlined"
            sx={{ mx: 1, minWidth: 110 }}
            onClick={() => setShowUncheckAutoInvest(false)}
          >
            Cancel
          </OutlinedButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

// ── Styles ────────────────────────────────────────────────────────────────────

const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};

const heroBanner = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 3, md: 3.5 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};

const heroContent = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  position: "relative",
  zIndex: 1,
};

const heroIconBadge = {
  width: 56,
  height: 56,
  borderRadius: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.25)",
  backdropFilter: "blur(6px)",
  flexShrink: 0,
};

const heroTitle = {
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.15,
  letterSpacing: "-0.015em",
};

const heroSubtitle = {
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  color: "rgba(255,255,255,0.88)",
  mt: 0.5,
  maxWidth: 580,
};

const statsStrip = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" },
  gap: 2,
  mb: 3,
};

const statCard = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  p: 2,
  backgroundColor: "var(--body-color-less)",
  border: "1px solid rgba(125,125,125,0.15)",
  borderRadius: "14px",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
  transition: "all 0.2s ease",
  "&:hover": {
    transform: "translateY(-1px)",
    boxShadow: "0 6px 16px rgba(0,0,0,0.10)",
  },
};

const statIconWrap = {
  width: 44,
  height: 44,
  borderRadius: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const statLabel = {
  fontSize: "0.82rem",
  fontWeight: 600,
  color: "var(--text-color)",
  lineHeight: 1.2,
};

const statSuffix = {
  fontSize: "0.68rem",
  color: "var(--text-color)",
  opacity: 0.5,
  mt: 0.15,
};

const statValueWrap = {
  textAlign: "right",
  flexShrink: 0,
};

const statValue = {
  fontSize: "1.2rem",
  fontWeight: 700,
  lineHeight: 1,
};

const mainCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const tabsWrap = {
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  px: { xs: 1, md: 2 },
  backgroundColor: "var(--body-color-less2)",
};

const tabsStyle = {
  minHeight: 56,
  "& .MuiTab-root": { minHeight: 56 },
};

const tabItem = {
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.9rem",
  color: "var(--text-color)",
  opacity: 0.65,
  letterSpacing: "0.01em",
  px: 2,
  gap: 0.75,
  "&.Mui-selected": { color: "var(--text-color)", opacity: 1 },
};

const tabPanel = {
  p: { xs: 2, md: 3 },
};

const modernTableContainer = {
  borderRadius: "12px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "none",
  overflowX: "auto",
  backgroundColor: "var(--body-color-less)",
};

const tableStyle = {
  minWidth: 1100,
};

const modernTableHeadRow = {
  backgroundColor: "var(--body-color-less2)",
};

const modernTableHeadCell = {
  fontWeight: 700,
  fontSize: "0.72rem",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.75,
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  py: 1.75,
  whiteSpace: "nowrap",
};

const modernTableBodyRow = {
  transition: "background-color 0.15s ease",
  "&:hover": { backgroundColor: "var(--body-color-less2)" },
  "&:last-child td": { borderBottom: 0 },
};

const modernTableBodyCell = {
  fontSize: "0.85rem",
  py: 1.65,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
  color: "var(--text-color)",
  whiteSpace: "nowrap",
};

const emptyCell = {
  textAlign: "center",
  py: 7,
  borderBottom: 0,
};

const emptyIcon = {
  fontSize: 48,
  color: "var(--text-color)",
  opacity: 0.35,
  mb: 1,
};

const emptyText = {
  fontSize: "0.92rem",
  color: "var(--text-color)",
  opacity: 0.65,
  maxWidth: 400,
  mx: "auto",
  lineHeight: 1.6,
};

// Dialogs
const dialogPaper = {
  borderRadius: "16px",
  minWidth: { xs: "85%", sm: 440 },
  boxShadow: "0 24px 60px rgba(0,0,0,0.28)",
  overflow: "hidden",
  backgroundColor: "var(--popupbody-color)",
  color: "var(--text-color)",
};

const dialogTitleStyle = {
  textAlign: "center",
  fontWeight: 700,
  fontSize: "1.05rem",
  py: 2.25,
  color: "var(--text-color)",
  backgroundColor: "var(--popupheader-color)",
  position: "relative",
};

const dialogCloseBtn = {
  position: "absolute",
  right: 12,
  top: "50%",
  transform: "translateY(-50%)",
  color: "var(--text-color)",
  opacity: 0.6,
};

const dialogContentStyle = {
  pt: 3,
  pb: 2,
  px: { xs: 2.5, md: 3 },
  backgroundColor: "var(--popupbody-color)",
};

const dialogText = {
  fontSize: "0.88rem",
  color: "var(--text-color)",
  opacity: 0.85,
  lineHeight: 1.65,
};

const dialogActionsStyle = {
  justifyContent: "center",
  px: 3,
  pb: 2.5,
  backgroundColor: "var(--popupbody-color)",
};

const redeemInfoGrid = {
  backgroundColor: "var(--body-color-less2)",
  borderRadius: "12px",
  border: "1px solid rgba(125,125,125,0.15)",
  overflow: "hidden",
};

const redeemInfoRow = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  px: 2,
  py: 1.5,
};

const redeemInfoLabel = {
  fontSize: "0.82rem",
  color: "var(--text-color)",
  opacity: 0.65,
};

const redeemInfoValue = {
  fontSize: "0.88rem",
  fontWeight: 700,
  color: "var(--text-color)",
};

const fieldLabelSmall = {
  fontSize: "0.72rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.6,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  mb: 0.75,
};

const dialogTextField = {
  "& .MuiInputBase-root": {
    borderRadius: "10px",
    backgroundColor: "var(--body-color-less2)",
    color: "var(--text-color)",
    fontSize: "0.9rem",
  },
  "& .MuiInputBase-input": { color: "var(--text-color)" },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.25)",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.45)",
  },
};

const warningText = {
  fontSize: "0.78rem",
  color: "#f59e0b",
  lineHeight: 1.55,
  mt: 1,
};

export default EarnWallet;
